import { render, staticRenderFns } from "./TileDataContainer.vue?vue&type=template&id=241237b0&"
import script from "./TileDataContainer.vue?vue&type=script&lang=js&"
export * from "./TileDataContainer.vue?vue&type=script&lang=js&"
import style0 from "./TileDataContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports